import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

export interface ModalProps {
  title: string
  onClose: () => void
  children: ReactNode
  /** Широкое окно — для формы в две колонки. */
  wide?: boolean
}

/**
 * Диалог поверх экрана. Рисуется порталом в body: внутри разметки он попал бы
 * под липкие шапку и панель. Escape и нажатие мимо окна закрывают — как ждут
 * от модального окна.
 */
export function Modal({ title, onClose, children, wide = false }: ModalProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      // Escape, который уже обработан внутри окна (закрыл открытый список
      // Select), окно не закрывает: иначе пропал бы и весь диалог.
      if (event.key === 'Escape' && !event.defaultPrevented) onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
    }
  }, [onClose])

  return createPortal(
    <div className="overlay">
      {/* Подложка — настоящая кнопка: нажатие мимо окна закрывает его и мышью,
          и с клавиатуры, а не только обработчиком на пустом блоке. */}
      <button type="button" className="overlay-close" aria-label="Закрыть окно" onClick={onClose} />
      <div
        className={wide ? 'mbox wide' : 'mbox'}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <h3>{title}</h3>
        {children}
      </div>
    </div>,
    document.body,
  )
}
